// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.op-mailroom-app{display:flex;height:100vh;padding:0}`, "",{"version":3,"sources":["webpack://./mailroomApp/App.scss"],"names":[],"mappings":"AAEA,iBACE,YAAA,CACA,YAAA,CACA,SAAA","sourcesContent":["@use 'assets/scss/common';\n\n.op-mailroom-app {\n  display: flex;\n  height: 100vh;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
